import { createEnum } from '../../constants/src/helpers'
import { CSV_UPLOAD_TYPES } from '../../csv/src/upload-types'

export const ASSORTMENTS_EVENT_TYPES = [
  'updateAssortment',
  'updateAssortmentBulk',
  'deleteAssortment',
  'replaceMaterialsInAssortment',
  'replaceMaterialsInLaunches',
  'addAssortmentFromNewMaterials',
  'publishAssortment',
  'publishAssortmentInitiated',
  'publishAssortmentCompleted',
  'publishAssortmentFailed',
] as const

export const PRICING_ASSUMPTIONS_EVENT_TYPES_VALUES = [
  'createPricingAssumption',
  'updatePricingAssumption',
  'deletePricingAssumptions',
  'createPricingAssumptionDetails',
  'updatePricingAssumptionDetails',
  'deletePricingAssumptionDetails',
] as const
export const PRICING_ASSUMPTIONS_EVENT_TYPES = createEnum(PRICING_ASSUMPTIONS_EVENT_TYPES_VALUES)

export const TAX_ASSUMPTIONS_EVENT_TYPES_VALUES = [
  'createTaxAssumption',
  'updateTaxAssumption',
  'deleteTaxAssumptions',
  'createTaxAssumptionDetails',
  'updateTaxAssumptionDetails',
  'deleteTaxAssumptionDetails',
] as const
export const TAX_ASSUMPTIONS_EVENT_TYPES = createEnum(TAX_ASSUMPTIONS_EVENT_TYPES_VALUES)

export const CHANNEL_MIX_EVENT_TYPES_VALUES = [
  'createChannelMix',
  'updateChannelMix',
  'deleteChannelMixes',
  'createChannelMixDetails',
] as const
export const CHANNEL_MIX_EVENT_TYPES = createEnum(CHANNEL_MIX_EVENT_TYPES_VALUES)

export const UNRELEASED_MATERIALS_EVENT_TYPES_VALUES = [
  'createUnreleasedMaterials',
  'updateUnreleasedMaterials',
  'deleteUnreleasedMaterials',
  'createUnreleasedMaterialDetails',
  'updateUnreleasedMaterialDetail',
  'updateUnreleasedMaterialDetails',
  'importUnreleasedMaterialDetails',
] as const
export const UNRELEASED_MATERIALS_EVENT_TYPES = createEnum(UNRELEASED_MATERIALS_EVENT_TYPES_VALUES)

export const PRODUCT_TYPE_VARIANT_EVENT_TYPES_VALUES = [
  'createProductTypeVariant',
  'updateProductTypeVariant',
  'deleteProductTypeVariants',
  'createProductTypeVariantDetails',
] as const
export const PRODUCT_TYPE_VARIANT_EVENT_TYPES = createEnum(PRODUCT_TYPE_VARIANT_EVENT_TYPES_VALUES)

export const AGREEMENT_EVENT_TYPES_VALUES = [
  'createAgreement',
  'updateAgreement',
  'deleteAgreements',
  'createAgreementDetails',
] as const
export const AGREEMENT_EVENT_TYPES = createEnum(AGREEMENT_EVENT_TYPES_VALUES)

export const SALES_DEAL_ACTUALS_EVENT_TYPES_VALUES = [
  'createSalesDealActuals',
  'updateSalesDealActuals',
  'deleteSalesDealActuals',
  'createSalesDealActualsDetails',
] as const
export const SALES_DEAL_ACTUALS_EVENT_TYPES = createEnum(SALES_DEAL_ACTUALS_EVENT_TYPES_VALUES)

export const OPERATIONS_EVENT_TYPES = [
  'executeEdiReprocess',
  'executeLambdaControl',
  'executeResend',
  'executeSchedulerTransfer',
  'executePleccProcess',
  'executeInvokeBcpJob',
  'executeMarkDeadFailedOrders',
] as const

export const SYNC_OPERATIONS_EVENT_TYPE_VALUES = [
  'executeSyncAccountSap',
  'executeSyncAccountNod',
  'executeSyncOrgHier',
  'executeSyncMaterial',
  'executeSyncResourceNod',
] as const
export const SYNC_OPERATIONS_EVENT_TYPES = createEnum(SYNC_OPERATIONS_EVENT_TYPE_VALUES)

export const FEDERAL_EXCISE_EVENT_TYPES_VALUES = ['updateFederalExciseMappings'] as const
export const FEDERAL_EXCISE_EVENT_TYPES = createEnum(FEDERAL_EXCISE_EVENT_TYPES_VALUES)

export const PRICE_LIST_SNAPSHOTS_EVENT_TYPES_VALUES = ['refreshPriceListSnapshot'] as const
export const PRICE_LIST_SNAPSHOTS_EVENT_TYPES = createEnum(PRICE_LIST_SNAPSHOTS_EVENT_TYPES_VALUES)

export const COST_OF_GOODS_EVENT_TYPES_VALUES = [
  'createCostOfGoods',
  'updateCostOfGoods',
  'deleteCostOfGoods',
  'createCostOfGoodsDetails',
] as const
export const COST_OF_GOODS_EVENT_TYPES = createEnum(COST_OF_GOODS_EVENT_TYPES_VALUES)

export const RAP_FORECASTS_EVENT_TYPES_VALUES = [
  'createRapForecast',
  'updateRapForecast',
  'deleteRapForecast',
  'createRapForecastDetails',
] as const
export const RAP_FORECASTS_EVENT_TYPES = createEnum(RAP_FORECASTS_EVENT_TYPES_VALUES)

export const DISTRIBUTION_MARGIN_MIX_EVENT_TYPES_VALUES = [
  'createDistributionMarginMix',
  'updateDistributionMarginMix',
  'deleteDistributionMarginMix',
  'createDistributionMarginMixDetails',
] as const
export const DISTRIBUTION_MARGIN_MIX_EVENT_TYPES = createEnum(
  DISTRIBUTION_MARGIN_MIX_EVENT_TYPES_VALUES,
)

export const DISTRIBUTION_BANNER_MIX_EVENT_TYPES_VALUES = ['updateDistributionBannerMix'] as const
export const DISTRIBUTION_BANNER_MIX_EVENT_TYPES = createEnum(
  DISTRIBUTION_BANNER_MIX_EVENT_TYPES_VALUES,
)

export const BUDGET_ALLOCATIONS_EVENT_TYPES_VALUES = [
  'createBudgetAllocation',
  'updateBudgetAllocation',
  'deleteBudgetAllocation',
  'createBudgetAllocationDetails',
  'createBudgetAllocationCustomDetail',
  'updateBudgetAllocationCustomDetail',
  'deleteBudgetAllocationCustomDetail',
] as const
export const BUDGET_ALLOCATIONS_EVENT_TYPES = createEnum(BUDGET_ALLOCATIONS_EVENT_TYPES_VALUES)

export const BUDGET_ESTIMATES_EVENT_TYPES_VALUES = [
  'copyBudgetEstimates',
  'updateBudgetEstimates',
  'updateBudgetLeftToSpendMonths',
] as const
export const BUDGET_ESTIMATES_EVENT_TYPES = createEnum(BUDGET_ESTIMATES_EVENT_TYPES_VALUES)

export const IP_ACCRUALS_EVENT_TYPES_VALUES = [
  'createIpAccrual',
  'updateIpAccrual',
  'deleteIpAccrual',
  'createIpAccrualDetails',
] as const
export const IP_ACCRUALS_EVENT_TYPES = createEnum(IP_ACCRUALS_EVENT_TYPES_VALUES)

export const CALCULATION_RUN_ACCRUALS_EVENT_TYPES_VALUES = [
  'createCalculationRunAccrual',
  'updateCalculationRunAccrual',
  'deleteCalculationRunAccrual',
  'createCalculationRunAccrualDetails',
] as const
export const CALCULATION_RUN_ACCRUALS_EVENT_TYPES = createEnum(
  CALCULATION_RUN_ACCRUALS_EVENT_TYPES_VALUES,
)

export const NC_PROVINCIAL_CONTRIBUTIONS_EVENT_TYPES_VALUES = [
  'createNcProvincialContribution',
  'updateNcProvincialContribution',
  'deleteNcProvincialContributions',
  'createNcProvincialContributionDetails',
] as const
export const NC_PROVINCIAL_CONTRIBUTIONS_EVENT_TYPES = createEnum(
  NC_PROVINCIAL_CONTRIBUTIONS_EVENT_TYPES_VALUES,
)

export const CHANNEL_CONTRIBUTIONS_EVENT_TYPES_VALUES = [
  'createChannelContribution',
  'updateChannelContribution',
  'deleteChannelContributions',
  'createChannelContributionDetails',
] as const
export const CHANNEL_CONTRIBUTIONS_EVENT_TYPES = createEnum(
  CHANNEL_CONTRIBUTIONS_EVENT_TYPES_VALUES,
)

export const BPC_ACTUALS_EVENT_TYPES_VALUES = [
  'createBpcActuals',
  'updateBpcActuals',
  'deleteBpcActuals',
  'createBpcActualsDetails',
] as const
export const BPC_ACTUALS_EVENT_TYPES = createEnum(BPC_ACTUALS_EVENT_TYPES_VALUES)

export const VOLUME_SCENARIOS_EVENT_TYPES_VALUES = [
  'createVolumeScenario',
  'updateVolumeScenario',
  'deleteVolumeScenarios',
  'createVolumeScenarioTarget',
  'updateVolumeScenarioTargetVolumes',
  'deleteVolumeScenarioTarget',
] as const
export const VOLUME_SCENARIOS_EVENT_TYPES = createEnum(VOLUME_SCENARIOS_EVENT_TYPES_VALUES)

export const KEY_ACCOUNT_CONTRACT_ESTIMATES_EVENT_TYPES_VALUES = [
  'createKeyAccountContractEstimates',
  'updateKeyAccountContractEstimates',
  'deleteKeyAccountContractEstimates',
  'copyKeyAccountContractEstimates',
  'updateKeyAccountContractRatios',
] as const
export const KEY_ACCOUNT_CONTRACT_ESTIMATES_EVENT_TYPES = createEnum(
  KEY_ACCOUNT_CONTRACT_ESTIMATES_EVENT_TYPES_VALUES,
)

export const MANUAL_INVESTMENTS_EVENT_TYPES_VALUES = [
  'createManualInvestment',
  'updateManualInvestment',
  'deleteManualInvestments',
  'bulkUpdateManualInvestmentCustomerTargets',
  'bulkUpdateManualInvestmentProductTargets',
  'bulkUpdateManualInvestmentMarkingTargets',
] as const
export const MANUAL_INVESTMENTS_EVENT_TYPES = createEnum(MANUAL_INVESTMENTS_EVENT_TYPES_VALUES)

export const CRT_CRT_VERSIONS_EVENT_TYPES_VALUES = [
  'createCrtVersion',
  'updateCrtVersion',
  'deleteCrtVersion',
] as const
export const CRT_CRT_VERSIONS_EVENT_TYPES = createEnum(CRT_CRT_VERSIONS_EVENT_TYPES_VALUES)

export const LMC_TARGETS_EVENT_TYPES_VALUES = ['saveLmcTargets'] as const
export const LMC_TARGETS_EVENT_TYPES = createEnum(LMC_TARGETS_EVENT_TYPES_VALUES)

export const CRT_NOTIFICATIONS_EVENT_TYPES_VALUES = ['updateCrtNotificationEvent'] as const
export const CRT_NOTIFICATIONS_EVENT_TYPES = createEnum(CRT_NOTIFICATIONS_EVENT_TYPES_VALUES)

export const CRT_AZURE_IMPORTS_EVENT_TYPES_VALUES = [
  'updateCrtAzureImportSettings',
  'deleteCrtAzureImport',
] as const
export const CRT_AZURE_IMPORTS_EVENT_TYPES = createEnum(CRT_AZURE_IMPORTS_EVENT_TYPES_VALUES)

export const RETAILER_RATES_EVENT_TYPES_VALUES = ['updateRetailerRates'] as const
export const RETAILER_RATES_EVENT_TYPES = createEnum(RETAILER_RATES_EVENT_TYPES_VALUES)

export const PRODUCT_TYPE_MAPPINGS_EVENT_TYPES_VALUES = ['updateProductTypeMappings'] as const
export const PRODUCT_TYPE_MAPPINGS_EVENT_TYPES = createEnum(
  PRODUCT_TYPE_MAPPINGS_EVENT_TYPES_VALUES,
)

export const MATERIAL_GROUP_OVERRIDES_EVENT_TYPES_VALUES = ['updateMaterialGroupOverrides'] as const
export const MATERIAL_GROUP_OVERRIDES_EVENT_TYPES = createEnum(
  MATERIAL_GROUP_OVERRIDES_EVENT_TYPES_VALUES,
)

export const AGREEMENT_MAPPINGS_EVENT_TYPES_VALUES = ['updateAgreementMappings'] as const
export const AGREEMENT_MAPPINGS_EVENT_TYPES = createEnum(AGREEMENT_MAPPINGS_EVENT_TYPES_VALUES)

export const RETAILER_MARGINS_FMC_EVENT_TYPES_VALUES = ['updateRetailerMarginsFmc'] as const
export const RETAILER_MARGINS_FMC_EVENT_TYPES = createEnum(RETAILER_MARGINS_FMC_EVENT_TYPES_VALUES)

export const RETAILER_MARGINS_NC_EVENT_TYPES_VALUES = ['updateRetailerMarginsNc'] as const
export const RETAILER_MARGINS_NC_EVENT_TYPES = createEnum(RETAILER_MARGINS_NC_EVENT_TYPES_VALUES)

export const WHOLESALER_MARGINS_FMC_EVENT_TYPES_VALUES = ['updateWholesalerMarginsFmc'] as const
export const WHOLESALER_MARGINS_FMC_EVENT_TYPES = createEnum(
  WHOLESALER_MARGINS_FMC_EVENT_TYPES_VALUES,
)

export const WHOLESALER_MARGINS_NC_EVENT_TYPES_VALUES = ['updateWholesalerMarginsNc'] as const
export const WHOLESALER_MARGINS_NC_EVENT_TYPES = createEnum(
  WHOLESALER_MARGINS_NC_EVENT_TYPES_VALUES,
)

export const SUB_CHANNEL_ALLOCATIONS_EVENT_TYPES_VALUES = ['updateSubChannelAllocations'] as const
export const SUB_CHANNEL_ALLOCATIONS_EVENT_TYPES = createEnum(
  SUB_CHANNEL_ALLOCATIONS_EVENT_TYPES_VALUES,
)

export const CONSUMER_RATES_EVENT_TYPES_VALUES = ['updateConsumerRates'] as const
export const CONSUMER_RATES_EVENT_TYPES = createEnum(CONSUMER_RATES_EVENT_TYPES_VALUES)

export const CURRENCY_RATES_EVENT_TYPES_VALUES = ['saveCurrencyRates'] as const
export const CURRENCY_RATES_EVENT_TYPES = createEnum(CURRENCY_RATES_EVENT_TYPES_VALUES)

const LAUNCHES_EVENT_TYPES = [
  'createLaunch',
  'cleanInactiveErpsInLaunches',
  'updateLaunch',
  'deleteLaunchErps',
  'deleteLaunchMaterials',
  'deleteInactiveLaunchErps',
  'deleteLaunches',
  'deleteObsoleteLaunchMaterials',
  'publishLaunches',
  'publishLaunchesInitiated',
  'publishLaunchesCompleted',
  'publishLaunchesFailed',
] as const

const ORDERS_EVENT_TYPES = [
  'releaseOrders',
  'updateDeliveryDate',
  'updateQuantities',
  'uncoupleOrder',
  'updateLegReleaseTimeout',
  'paymentTermReview',
] as const

const USERS_EVENT_TYPES = ['activateUser', 'disableUser'] as const

const PERMISSIONS_EVENT_TYPES = ['updateRoles', 'updatePermissionsOverrides'] as const

const TERRITORIES_OVERRIDES_EVENT_TYPES = ['updateTerritoriesOverrides'] as const

const INVITES_EVENT_TYPES = ['sendInvites', 'deleteInvites'] as const

/**
 * Core admin events that the CRT and Credit admin screens also raise. Each module's `trail` accepts
 * these on top of its own event types and files the row in its own `audit_trails`, so the same
 * event type can legitimately live in any of the three tables.
 */
export const SHARED_ADMIN_EVENT_TYPES = [
  ...USERS_EVENT_TYPES,
  ...PERMISSIONS_EVENT_TYPES,
  ...INVITES_EVENT_TYPES,
] as const
export type SharedAdminEventType = (typeof SHARED_ADMIN_EVENT_TYPES)[number]

export const UPLOAD_S3_EVENT_TYPES = ['uploadS3CoreData', 'uploadS3AppData'] as const

export const CORE_EVENT_TYPES = [
  ...ASSORTMENTS_EVENT_TYPES,
  ...LAUNCHES_EVENT_TYPES,
  ...ORDERS_EVENT_TYPES,
  ...USERS_EVENT_TYPES,
  ...PERMISSIONS_EVENT_TYPES,
  ...INVITES_EVENT_TYPES,
  ...UPLOAD_S3_EVENT_TYPES,
  ...TERRITORIES_OVERRIDES_EVENT_TYPES,
  ...OPERATIONS_EVENT_TYPES,
  ...SYNC_OPERATIONS_EVENT_TYPE_VALUES,
] as const

export const CRT_EVENT_TYPES = [
  ...PRICING_ASSUMPTIONS_EVENT_TYPES_VALUES,
  ...TAX_ASSUMPTIONS_EVENT_TYPES_VALUES,
  ...CHANNEL_MIX_EVENT_TYPES_VALUES,
  ...UNRELEASED_MATERIALS_EVENT_TYPES_VALUES,
  ...PRODUCT_TYPE_VARIANT_EVENT_TYPES_VALUES,
  ...AGREEMENT_EVENT_TYPES_VALUES,
  ...SALES_DEAL_ACTUALS_EVENT_TYPES_VALUES,
  ...FEDERAL_EXCISE_EVENT_TYPES_VALUES,
  ...PRICE_LIST_SNAPSHOTS_EVENT_TYPES_VALUES,
  ...RETAILER_RATES_EVENT_TYPES_VALUES,
  ...PRODUCT_TYPE_MAPPINGS_EVENT_TYPES_VALUES,
  ...MATERIAL_GROUP_OVERRIDES_EVENT_TYPES_VALUES,
  ...AGREEMENT_MAPPINGS_EVENT_TYPES_VALUES,
  ...RETAILER_MARGINS_FMC_EVENT_TYPES_VALUES,
  ...RETAILER_MARGINS_NC_EVENT_TYPES_VALUES,
  ...WHOLESALER_MARGINS_FMC_EVENT_TYPES_VALUES,
  ...WHOLESALER_MARGINS_NC_EVENT_TYPES_VALUES,
  ...SUB_CHANNEL_ALLOCATIONS_EVENT_TYPES_VALUES,
  ...CONSUMER_RATES_EVENT_TYPES_VALUES,
  ...CURRENCY_RATES_EVENT_TYPES_VALUES,
  ...COST_OF_GOODS_EVENT_TYPES_VALUES,
  ...RAP_FORECASTS_EVENT_TYPES_VALUES,
  ...DISTRIBUTION_MARGIN_MIX_EVENT_TYPES_VALUES,
  ...DISTRIBUTION_BANNER_MIX_EVENT_TYPES_VALUES,
  ...BUDGET_ALLOCATIONS_EVENT_TYPES_VALUES,
  ...BUDGET_ESTIMATES_EVENT_TYPES_VALUES,
  ...IP_ACCRUALS_EVENT_TYPES_VALUES,
  ...CALCULATION_RUN_ACCRUALS_EVENT_TYPES_VALUES,
  ...NC_PROVINCIAL_CONTRIBUTIONS_EVENT_TYPES_VALUES,
  ...CHANNEL_CONTRIBUTIONS_EVENT_TYPES_VALUES,
  ...BPC_ACTUALS_EVENT_TYPES_VALUES,
  ...VOLUME_SCENARIOS_EVENT_TYPES_VALUES,
  ...KEY_ACCOUNT_CONTRACT_ESTIMATES_EVENT_TYPES_VALUES,
  ...MANUAL_INVESTMENTS_EVENT_TYPES_VALUES,
  ...CRT_CRT_VERSIONS_EVENT_TYPES_VALUES,
  ...LMC_TARGETS_EVENT_TYPES_VALUES,
  ...CRT_NOTIFICATIONS_EVENT_TYPES_VALUES,
  ...CRT_AZURE_IMPORTS_EVENT_TYPES_VALUES,
] as const

export const CREDIT_INDEX_SCORES_EVENT_TYPES_VALUES = [
  'importCreditIndexScores',
  'deleteCreditIndexScoreImport',
  'createCreditIndexScore',
  'updateCreditIndexScore',
  'deleteCreditIndexScore',
] as const
export const CREDIT_INDEX_SCORES_EVENT_TYPES = createEnum(CREDIT_INDEX_SCORES_EVENT_TYPES_VALUES)

export const GOOGLE_FINANCIAL_STATEMENTS_EVENT_TYPES_VALUES = [
  'importGoogleFinancialStatements',
  'deleteGoogleFinancialStatementImport',
  'updateGoogleFinancialStatementComment',
] as const
export const GOOGLE_FINANCIAL_STATEMENTS_EVENT_TYPES = createEnum(
  GOOGLE_FINANCIAL_STATEMENTS_EVENT_TYPES_VALUES,
)

export const DELEGATION_OF_AUTHORITY_EVENT_TYPES_VALUES = [
  'saveDelegationOfAuthorityAssignments',
  // Its own event so the exception page's "last updated" footer doesn't move when someone edits
  // the band matrix — and so an auditor can filter the bypass list's history on its own.
  'saveBlockedOrderExceptionPayers',
  // The flat list of CLR preparers (single and mass), edited from the DOA configuration drawer.
  'saveClrPreparers',
] as const
export const DELEGATION_OF_AUTHORITY_EVENT_TYPES = createEnum(
  DELEGATION_OF_AUTHORITY_EVENT_TYPES_VALUES,
)

export const MULTIPLIERS_EVENT_TYPES_VALUES = ['updateMultipliers'] as const
export const MULTIPLIERS_EVENT_TYPES = createEnum(MULTIPLIERS_EVENT_TYPES_VALUES)

export const PROVINCE_AOV_EVENT_TYPES_VALUES = ['updateProvinceAovPerCarton'] as const
export const PROVINCE_AOV_EVENT_TYPES = createEnum(PROVINCE_AOV_EVENT_TYPES_VALUES)

export const PROVINCE_ORDER_CUTOFF_EVENT_TYPES_VALUES = ['updateProvinceOrderCutoffs'] as const
export const PROVINCE_ORDER_CUTOFF_EVENT_TYPES = createEnum(
  PROVINCE_ORDER_CUTOFF_EVENT_TYPES_VALUES,
)

export const SAP_IMPORTS_EVENT_TYPES_VALUES = [
  'importSapCustomer',
  'importSapCustomerCompany',
  'importSapPartnerFunctions',
  'importSapSalesOrders',
  'importSapBillingDocuments',
  'importSapBillingDocumentDetails',
  'importSapCustomerTransactions',
  'importSapCustomerPartnerCreditSegments',
  'importRclMultipliers',
  'importProvinceAovPerCarton',
  'deleteSapCustomer',
  'deleteSapCustomerCompany',
  'deleteSapPartnerFunctions',
  'deleteSapSalesOrders',
  'deleteSapBillingDocuments',
  'deleteSapBillingDocumentDetails',
  'deleteSapCustomerTransactions',
  'deleteSapCustomerPartnerCreditSegments',
] as const
export const SAP_IMPORTS_EVENT_TYPES = createEnum(SAP_IMPORTS_EVENT_TYPES_VALUES)

export const CUSTOMERS_EVENT_TYPES_VALUES = [
  'updateCustomerDuns',
  'importDunsAndBradstreet',
  'addVeryLowRiskCustomer',
  'deleteVeryLowRiskCustomer',
] as const
export const CUSTOMERS_EVENT_TYPES = createEnum(CUSTOMERS_EVENT_TYPES_VALUES)

export const CREDIT_LIMIT_REVIEWS_EVENT_TYPES_VALUES = [
  'createCreditLimitReview',
  'resubmitCreditLimitReview',
  'reviewCreditLimitReview',
  'approveCreditLimitReview',
  'rejectCreditLimitReview',
  'sendBackCreditLimitReview',
  // The SAP hand-off of an approved review: written by the worker, not by a user action.
  'dispatchCreditLimitReviewToSap',
  'failCreditLimitReviewSapDispatch',
  'confirmCreditLimitReviewInSap',
] as const

/**
 * The SAP hand-off of a decided blocked order (CT-34): written by the worker, not by a user action,
 * so the trail shows when SAP was told and when its case showed it acted.
 */
export const BLOCKED_ORDERS_EVENT_TYPES_VALUES = [
  'dispatchBlockedOrderDecisionToSap',
  'failBlockedOrderSapDispatch',
  'confirmBlockedOrderDecisionInSap',
] as const
export const BLOCKED_ORDERS_EVENT_TYPES = createEnum(BLOCKED_ORDERS_EVENT_TYPES_VALUES)

export const MASS_CREDIT_LIMIT_REVIEWS_EVENT_TYPES_VALUES = [
  'createMassCreditLimitReview',
  'submitMassCreditLimitReview',
  'cancelMassCreditLimitReview',
  'reviewMassCreditLimitReview',
  'approveMassCreditLimitReview',
  'rejectMassCreditLimitReview',
  'sendBackMassCreditLimitReview',
  // No producer since the reviewer slot went (phase 2 UAT); kept so persisted rows stay typed.
  'patchMassClrLinesAsReviewer',
  'commentMassClrLines',
  'excludeMassClrLines',
  'restoreMassClrLines',
  // The SAP hand-off, one event per line of an approved run.
  'dispatchMassCreditLimitReviewLineToSap',
  'failMassCreditLimitReviewLineSapDispatch',
  'confirmMassCreditLimitReviewLineInSap',
] as const

export const INITIATIVES_EVENT_TYPES_VALUES = [
  'createInitiative',
  'updateInitiative',
  'deleteInitiative',
  'importInitiativeVersion',
  'deleteInitiativeVersion',
  'sendInitiativeForReview',
  'sendInitiativeFinal',
  'initiativeChainAction',
  'startInitiative',
  'stopInitiative',
  'exportInitiative',
  'patchInitiativeRows',
  'configureInitiativeBuffers',
] as const

export const USER_VACATIONS_EVENT_TYPES_VALUES = [
  'createUserVacation',
  'updateUserVacation',
  'deleteUserVacation',
] as const
export const USER_VACATIONS_EVENT_TYPES = createEnum(USER_VACATIONS_EVENT_TYPES_VALUES)

export const CREDIT_EVENT_TYPES = [
  ...CREDIT_INDEX_SCORES_EVENT_TYPES_VALUES,
  ...GOOGLE_FINANCIAL_STATEMENTS_EVENT_TYPES_VALUES,
  ...DELEGATION_OF_AUTHORITY_EVENT_TYPES_VALUES,
  ...MULTIPLIERS_EVENT_TYPES_VALUES,
  ...PROVINCE_AOV_EVENT_TYPES_VALUES,
  ...PROVINCE_ORDER_CUTOFF_EVENT_TYPES_VALUES,
  ...SAP_IMPORTS_EVENT_TYPES_VALUES,
  ...CUSTOMERS_EVENT_TYPES_VALUES,
  ...CREDIT_LIMIT_REVIEWS_EVENT_TYPES_VALUES,
  ...BLOCKED_ORDERS_EVENT_TYPES_VALUES,
  ...MASS_CREDIT_LIMIT_REVIEWS_EVENT_TYPES_VALUES,
  ...INITIATIVES_EVENT_TYPES_VALUES,
  ...USER_VACATIONS_EVENT_TYPES_VALUES,
] as const

export const EVENT_TYPES = [...CORE_EVENT_TYPES, ...CRT_EVENT_TYPES, ...CREDIT_EVENT_TYPES] as const

export type EventTypes = (typeof EVENT_TYPES)[number]
export type CoreEventType = (typeof CORE_EVENT_TYPES)[number]
export type CrtEventType = (typeof CRT_EVENT_TYPES)[number]
export type CreditEventType = (typeof CREDIT_EVENT_TYPES)[number]

type LaunchesTargets = {
  createLaunch: { launchId: number }
  cleanInactiveErpsInLaunches: null
  updateLaunch: { launchId: number }
  deleteLaunchErps: { launchId: number }
  deleteLaunchMaterials: { launchId: number }
  deleteInactiveLaunchErps: { launchId: number }
  deleteLaunches: null
  deleteObsoleteLaunchMaterials: null
  publishLaunches: null
  publishLaunchesInitiated: null
  publishLaunchesCompleted: null
  publishLaunchesFailed: null
}

type PricingAssumptionsTargets = {
  createPricingAssumption: { entityId: number }
  updatePricingAssumption: { entityId: number }
  deletePricingAssumptions: null
  createPricingAssumptionDetails: { entityId: number }
  updatePricingAssumptionDetails: { entityId: number }
  deletePricingAssumptionDetails: { entityId: number }
}

type TaxAssumptionsTargets = {
  createTaxAssumption: { entityId: number }
  updateTaxAssumption: { entityId: number }
  deleteTaxAssumptions: null
  createTaxAssumptionDetails: { entityId: number }
  updateTaxAssumptionDetails: { entityId: number }
  deleteTaxAssumptionDetails: { entityId: number }
}

type ChannelMixTargets = {
  createChannelMix: { entityId: number }
  updateChannelMix: { entityId: number }
  deleteChannelMixes: null
  createChannelMixDetails: { entityId: number }
}

type UnreleasedMaterialsTargets = {
  createUnreleasedMaterials: { entityId: number }
  updateUnreleasedMaterials: { entityId: number }
  deleteUnreleasedMaterials: null
  createUnreleasedMaterialDetails: { entityId: number }
  updateUnreleasedMaterialDetail: { entityId: number }
  updateUnreleasedMaterialDetails: { entityId: number }
  importUnreleasedMaterialDetails: null
}

type ProductTypeVariantTargets = {
  createProductTypeVariant: { entityId: number }
  updateProductTypeVariant: { entityId: number }
  deleteProductTypeVariants: null
  createProductTypeVariantDetails: { entityId: number }
}

type AgreementTargets = {
  createAgreement: { entityId: number }
  updateAgreement: { entityId: number }
  deleteAgreements: null
  createAgreementDetails: { entityId: number }
}

type SalesDealActualsTargets = {
  createSalesDealActuals: { entityId: number }
  updateSalesDealActuals: { entityId: number }
  deleteSalesDealActuals: null
  createSalesDealActualsDetails: { entityId: number }
}

type OperationsTargets = {
  executeEdiReprocess: null
  executeLambdaControl: null
  executeResend: null
  executeSchedulerTransfer: null
  executePleccProcess: null
  executeInvokeBcpJob: null
  executeMarkDeadFailedOrders: null
}

type SyncOperationsTargets = {
  executeSyncAccountSap: null
  executeSyncAccountNod: null
  executeSyncOrgHier: null
  executeSyncMaterial: null
  executeSyncResourceNod: null
}

type FederalExciseTargets = {
  updateFederalExciseMappings: null
  refreshPriceListSnapshot: null
}

type RetailerRatesTargets = {
  updateRetailerRates: null
}

type ProductTypeMappingsTargets = {
  updateProductTypeMappings: null
}

type MaterialGroupOverridesTargets = {
  updateMaterialGroupOverrides: null
}

type AgreementMappingsTargets = {
  updateAgreementMappings: null
}

type RetailerMarginsFmcTargets = {
  updateRetailerMarginsFmc: null
}

type RetailerMarginsNcTargets = {
  updateRetailerMarginsNc: null
}

type WholesalerMarginsFmcTargets = {
  updateWholesalerMarginsFmc: null
}

type WholesalerMarginsNcTargets = {
  updateWholesalerMarginsNc: null
}

type SubChannelAllocationsTargets = {
  updateSubChannelAllocations: null
}

type ConsumerRatesTargets = {
  updateConsumerRates: null
}

type CurrencyRatesTargets = {
  saveCurrencyRates: null
}

type CostOfGoodsTargets = {
  createCostOfGoods: { entityId: number }
  updateCostOfGoods: { entityId: number }
  deleteCostOfGoods: null
  createCostOfGoodsDetails: { entityId: number }
}

type RapForecastsTargets = {
  createRapForecast: { entityId: number }
  updateRapForecast: { entityId: number }
  deleteRapForecast: null
  createRapForecastDetails: { entityId: number }
}

type DistributionMarginMixTargets = {
  createDistributionMarginMix: { entityId: number }
  updateDistributionMarginMix: { entityId: number }
  deleteDistributionMarginMix: null
  createDistributionMarginMixDetails: { entityId: number }
}

type DistributionBannerMixTargets = {
  updateDistributionBannerMix: null
}

type BudgetAllocationsTargets = {
  createBudgetAllocation: { entityId: number }
  updateBudgetAllocation: { entityId: number }
  deleteBudgetAllocation: null
  createBudgetAllocationDetails: { entityId: number }
  createBudgetAllocationCustomDetail: { entityId: number }
  updateBudgetAllocationCustomDetail: { entityId: number }
  deleteBudgetAllocationCustomDetail: { entityId: number } | null
}

type BudgetEstimatesTargets = {
  copyBudgetEstimates: null
  updateBudgetEstimates: null
  updateBudgetLeftToSpendMonths: null
}

type IpAccrualsTargets = {
  createIpAccrual: { entityId: number }
  updateIpAccrual: { entityId: number }
  deleteIpAccrual: null
  createIpAccrualDetails: { entityId: number }
}

type CalculationRunAccrualsTargets = {
  createCalculationRunAccrual: { entityId: number }
  updateCalculationRunAccrual: { entityId: number }
  deleteCalculationRunAccrual: null
  createCalculationRunAccrualDetails: { entityId: number }
}

type NcProvincialContributionsTargets = {
  createNcProvincialContribution: { entityId: number }
  updateNcProvincialContribution: { entityId: number }
  deleteNcProvincialContributions: null
  createNcProvincialContributionDetails: { entityId: number }
}

type ChannelContributionsTargets = {
  createChannelContribution: { entityId: number }
  updateChannelContribution: { entityId: number }
  deleteChannelContributions: null
  createChannelContributionDetails: { entityId: number }
}

type VolumeScenariosTargets = {
  createVolumeScenario: { entityId: number }
  updateVolumeScenario: { entityId: number }
  deleteVolumeScenarios: null
  createVolumeScenarioTarget: { entityId: number }
  updateVolumeScenarioTargetVolumes: { entityId: number }
  deleteVolumeScenarioTarget: null
}

type BpcActualsTargets = {
  createBpcActuals: { entityId: number }
  updateBpcActuals: { entityId: number }
  deleteBpcActuals: null
  createBpcActualsDetails: { entityId: number }
}

type KeyAccountContractEstimatesTargets = {
  createKeyAccountContractEstimates: null
  updateKeyAccountContractEstimates: null
  deleteKeyAccountContractEstimates: null
  copyKeyAccountContractEstimates: null
  updateKeyAccountContractRatios: null
}

type ManualInvestmentsTargets = {
  createManualInvestment: { entityId: number }
  updateManualInvestment: { entityId: number }
  deleteManualInvestments: null
  bulkUpdateManualInvestmentCustomerTargets: { entityId: number }
  bulkUpdateManualInvestmentProductTargets: { entityId: number }
  bulkUpdateManualInvestmentMarkingTargets: { entityId: number }
}

type CrtVersionsTargets = {
  createCrtVersion: { entityId: number }
  updateCrtVersion: { entityId: number }
  deleteCrtVersion: { entityId: number }
}

type LmcTargetsTargets = {
  // entityId is the configuration year the targets belong to.
  saveLmcTargets: { entityId: number }
}

type CrtNotificationsTargets = {
  // entityId is the `notification_events` row.
  updateCrtNotificationEvent: { entityId: number }
}

type CrtAzureImportsTargets = {
  // entityId is the `azure_import_settings` row.
  updateCrtAzureImportSettings: { entityId: number }
  // entityId is the deleted `uploads_from_azure` row.
  deleteCrtAzureImport: { entityId: number }
}

type CreditIndexScoresTargets = {
  importCreditIndexScores: { sapErp: string } | null
  deleteCreditIndexScoreImport: { entityId: number }
  createCreditIndexScore: { entityId: number; sapErp: string }
  updateCreditIndexScore: { entityId: number; sapErp: string }
  deleteCreditIndexScore: { entityId: number; sapErp: string }
}

type GoogleFinancialStatementsTargets = {
  importGoogleFinancialStatements: { inserted: number; unchanged: number; fileName: string } | null
  deleteGoogleFinancialStatementImport: { entityId: number }
  updateGoogleFinancialStatementComment: { sapErp: string }
}

type DelegationOfAuthorityTargets = {
  saveDelegationOfAuthorityAssignments: null
  saveBlockedOrderExceptionPayers: null
  saveClrPreparers: null
}

type UserVacationsTargets = {
  createUserVacation: { userId: string }
  updateUserVacation: { userId: string }
  deleteUserVacation: { userId: string }
}

type MultipliersTargets = {
  updateMultipliers: null
}

type ProvinceAovTargets = {
  updateProvinceAovPerCarton: null
}

type ProvinceOrderCutoffTargets = {
  updateProvinceOrderCutoffs: null
}

type SapImportsTargets = {
  importSapCustomer: { rowCount: number; fileName: string } | null
  importSapCustomerCompany: { rowCount: number; fileName: string } | null
  importSapPartnerFunctions: { rowCount: number; fileName: string } | null
  importSapSalesOrders: { rowCount: number; fileName: string } | null
  importSapBillingDocuments: { rowCount: number; fileName: string } | null
  importSapBillingDocumentDetails: { rowCount: number; fileName: string } | null
  importSapCustomerTransactions: { rowCount: number; fileName: string } | null
  importSapCustomerPartnerCreditSegments: { rowCount: number; fileName: string } | null
  importRclMultipliers: { rowCount: number; fileName: string } | null
  importProvinceAovPerCarton: { rowCount: number; fileName: string } | null
  deleteSapCustomer: null
  deleteSapCustomerCompany: null
  deleteSapPartnerFunctions: null
  deleteSapSalesOrders: null
  deleteSapBillingDocuments: null
  deleteSapBillingDocumentDetails: null
  deleteSapCustomerTransactions: null
  deleteSapCustomerPartnerCreditSegments: null
}

type CustomersTargets = {
  updateCustomerDuns: { sapErp: string }
  importDunsAndBradstreet: { rowCount: number; fileName: string } | null
  addVeryLowRiskCustomer: { count: number }
  deleteVeryLowRiskCustomer: { count: number }
}

type CreditLimitReviewsTargets = {
  createCreditLimitReview: { entityId: number; sapErp: string }
  resubmitCreditLimitReview: { entityId: number; sapErp: string }
  reviewCreditLimitReview: { entityId: number; sapErp: string }
  approveCreditLimitReview: { entityId: number; sapErp: string }
  rejectCreditLimitReview: { entityId: number; sapErp: string }
  sendBackCreditLimitReview: { entityId: number; sapErp: string }
  dispatchCreditLimitReviewToSap: { entityId: number; sapErp: string }
  failCreditLimitReviewSapDispatch: { entityId: number; sapErp: string }
  confirmCreditLimitReviewInSap: { entityId: number; sapErp: string }
}

// The entity is the order snapshot; the payer is named so the account's history finds it.
type BlockedOrdersTargets = {
  dispatchBlockedOrderDecisionToSap: { entityId: number; sapErp: string }
  failBlockedOrderSapDispatch: { entityId: number; sapErp: string }
  confirmBlockedOrderDecisionInSap: { entityId: number; sapErp: string }
}

// A mass run has no single sapErp — the accounts are line items inside the container.
type MassCreditLimitReviewsTargets = {
  createMassCreditLimitReview: { entityId: number }
  submitMassCreditLimitReview: { entityId: number }
  cancelMassCreditLimitReview: { entityId: number }
  reviewMassCreditLimitReview: { entityId: number }
  approveMassCreditLimitReview: { entityId: number }
  rejectMassCreditLimitReview: { entityId: number }
  sendBackMassCreditLimitReview: { entityId: number }
  patchMassClrLinesAsReviewer: { entityId: number }
  commentMassClrLines: { entityId: number }
  excludeMassClrLines: { entityId: number }
  restoreMassClrLines: { entityId: number }
  // Per line, so the account is named even though the entity is the run.
  dispatchMassCreditLimitReviewLineToSap: { entityId: number; sapErp: string }
  failMassCreditLimitReviewLineSapDispatch: { entityId: number; sapErp: string }
  confirmMassCreditLimitReviewLineInSap: { entityId: number; sapErp: string }
}

type InitiativesTargets = {
  createInitiative: { entityId: number }
  updateInitiative: { entityId: number }
  deleteInitiative: { entityId: number }
  importInitiativeVersion: { entityId: number }
  deleteInitiativeVersion: { entityId: number }
  sendInitiativeForReview: { entityId: number }
  sendInitiativeFinal: { entityId: number }
  initiativeChainAction: { entityId: number }
  startInitiative: { entityId: number }
  stopInitiative: { entityId: number }
  exportInitiative: { entityId: number }
  patchInitiativeRows: { entityId: number }
  configureInitiativeBuffers: { entityId: number }
}

export type Targets = {
  updateAssortment: null
  updateAssortmentBulk: null
  deleteAssortment: { backupId: number }
  replaceMaterialsInAssortment: { backupId: number }
  replaceMaterialsInLaunches: null
  addAssortmentFromNewMaterials: null
  publishAssortment: null
  publishAssortmentInitiated: null
  publishAssortmentCompleted: null
  publishAssortmentFailed: null
  releaseOrders: { orderPoNumber: string; sapErp: string }
  updateDeliveryDate: { orderPoNumber: string; sapErp: string }
  updateQuantities: { orderPoNumber: string; sapErp: string }
  /**
   * No `orderPoNumber`: a coupled order's legs are viewed and uncoupled together, so filing the row
   * under one leg's PO would misrepresent it, and the schema has no parent PO to use instead. Both
   * legs are identified in the event data, along with the dynamo src id they share.
   */
  uncoupleOrder: { sapErp: string }
  updateLegReleaseTimeout: null
  /**
   * One row per order acted on, so a multi-select action writes several. `accepted` is false when
   * Fuze Core skipped the order, with their reason, because a 200 does not mean it moved.
   */
  paymentTermReview: {
    orderPoNumber: string
    sapErp: string
    operation: string
    paymentTerms: string
    accepted: boolean
    reason?: string
  }
  activateUser: { userId: string }
  disableUser: { userId: string }
  updateRoles: { userId: string }
  updatePermissionsOverrides: { userId: string }
  updateTerritoriesOverrides: { userId: string }
  sendInvites: null
  deleteInvites: null
  uploadS3CoreData: { s3UploadType: (typeof CSV_UPLOAD_TYPES)[number] }
  uploadS3AppData: { s3UploadType: (typeof CSV_UPLOAD_TYPES)[number] }
} & LaunchesTargets &
  PricingAssumptionsTargets &
  TaxAssumptionsTargets &
  ChannelMixTargets &
  UnreleasedMaterialsTargets &
  ProductTypeVariantTargets &
  AgreementTargets &
  SalesDealActualsTargets &
  OperationsTargets &
  SyncOperationsTargets &
  FederalExciseTargets &
  RetailerRatesTargets &
  ProductTypeMappingsTargets &
  MaterialGroupOverridesTargets &
  AgreementMappingsTargets &
  RetailerMarginsFmcTargets &
  RetailerMarginsNcTargets &
  WholesalerMarginsFmcTargets &
  WholesalerMarginsNcTargets &
  SubChannelAllocationsTargets &
  ConsumerRatesTargets &
  CurrencyRatesTargets &
  CostOfGoodsTargets &
  RapForecastsTargets &
  DistributionMarginMixTargets &
  DistributionBannerMixTargets &
  BudgetAllocationsTargets &
  BudgetEstimatesTargets &
  IpAccrualsTargets &
  CalculationRunAccrualsTargets &
  NcProvincialContributionsTargets &
  ChannelContributionsTargets &
  BpcActualsTargets &
  VolumeScenariosTargets &
  KeyAccountContractEstimatesTargets &
  ManualInvestmentsTargets &
  CrtVersionsTargets &
  LmcTargetsTargets &
  CrtNotificationsTargets &
  CrtAzureImportsTargets &
  CreditIndexScoresTargets &
  GoogleFinancialStatementsTargets &
  DelegationOfAuthorityTargets &
  MultipliersTargets &
  ProvinceAovTargets &
  ProvinceOrderCutoffTargets &
  SapImportsTargets &
  CustomersTargets &
  CreditLimitReviewsTargets &
  BlockedOrdersTargets &
  MassCreditLimitReviewsTargets &
  InitiativesTargets &
  UserVacationsTargets
